import { getMonth } from 'date-fns';
import { formatDate } from './formatDate';

export const getCurrentMonthName = (query, timezone) => {
  const hasAlreadyDate =
    query?.startDate &&
    new Date(formatDate(query?.startDate, 'timestamp', timezone));

  const currentMonth = getMonth(
    hasAlreadyDate ?? new Date(formatDate(new Date(), 'timestamp', timezone))
  );

  const months = new Map([
    [0, { month: 0, monthLocale: 'Janeiro' }],
    [1, { month: 1, monthLocale: 'Fevereiro' }],
    [2, { month: 2, monthLocale: 'Março' }],
    [3, { month: 3, monthLocale: 'Abril' }],
    [4, { month: 4, monthLocale: 'Maio' }],
    [5, { month: 5, monthLocale: 'Junho' }],
    [6, { month: 6, monthLocale: 'Julho' }],
    [7, { month: 7, monthLocale: 'Agosto' }],
    [8, { month: 8, monthLocale: 'Setembro' }],
    [9, { month: 9, monthLocale: 'Outubro' }],
    [10, { month: 10, monthLocale: 'Novembro' }],
    [11, { month: 11, monthLocale: 'Dezembro' }],
  ]);

  return months.get(currentMonth);
};
